<span matTooltip="{{ pathLengthInCommercialUnit + ' ' + commercialUnit }} / {{ pathLengthInTechnicalUnit }} {{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}">
  <span>{{ pathLengthInCommercialUnit }} </span>
  <span class="font-weight-semibold">{{ commercialUnit }}</span>
  <span> / {{ pathLengthInTechnicalUnit }} </span>
  <span class="font-weight-semibold">{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</span>
</span>
